import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import eye from "assets/images/eye.svg";
import arrow_right_circle from "assets/images/arrow_right_circle.svg";
import circle_left from "assets/images/circle_left.svg";
import circle_right from "assets/images/circle_right.svg";
import { PrimaryButton } from "components/buttons";
import { newsList as localfull_news } from "constants/full_news";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import alrajhi_logo from "assets/images/alrajhi_logo.svg";
import parse from "html-react-parser";
import axios from "axios";
import { isArray } from "lodash";
import moment from "moment";

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  nextArrow: <img src={circle_right} alt="circle_right" />,
  prevArrow: <img src={circle_left} alt="circle_left" />,
  adaptiveHeight: true,
  slidesToShow: 4,
  slidesToScroll: 4,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1399,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: null,
        prevArrow: null,
      },
    },
  ],
};

const News = () => {
  const navigate = useNavigate();
  const [newsList, setNewsList] = useState(localfull_news);
  const [tags, setTags] = useState([]);
  const [activeTag, setActiveTag] = useState("");

  const fetchNewsAndAnnouncementsCMS = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CMS_BASE_URL}/news-and-announcements?sort=createdAt:desc&populate=*`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
          },
        }
      );
      return response.data.data;
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    const fetchAdditionalData = async () => {
      try {
        const response = await fetch(
          "https://www.alrajhibank.com.my/assets/json/news.json"
        );
        const fetchedData = await response.json();
        const fetchDataCMS = await fetchNewsAndAnnouncementsCMS();

        const formattedCMSData =
          isArray(fetchDataCMS) &&
          fetchDataCMS.map((data) => ({
            // id: data.id,
            type: data.type || "News",
            title: data.title,
            date: moment(data.date).format("DD MMM YYYY"),
            tag: data.yearTag,
            slug: data.slug,
            description: data.contentTemplate,
            image: data.image,
            isFromCMS: true,
          }));

        const mergedData = [
          ...formattedCMSData,
          ...fetchedData.newsList,
          ...localfull_news,
        ];

        const uniqueTags = [...new Set(mergedData.map((item) => item.tag))];
        setTags(uniqueTags);
        setActiveTag(uniqueTags[0]);
        setNewsList(mergedData);
      } catch (error) {
        console.error("Error fetching news data:", error);
      }
    };

    fetchAdditionalData();
  }, []);

  return (
    <section className="section news">
      <div className="container">
        <div className="text-center">
          <h1 className="fw-bolder">News & Announcements</h1>
        </div>
        <div className="tag-container text-center pt-3"></div>
      </div>
      <div className="container news-content pt-5">
        <Slider {...settings}>
          {newsList
            // .filter((news) => news.tag === activeTag)
            .map((news) => (
              <div className="personal-promotion-item" key={news.id}>
                <Card
                  style={{
                    width: "300px",
                    borderRadius: "20px",
                    border: "none",
                  }}
                  className="mx-5 shadow"
                  data-aos="fade-left"
                  data-aos-delay={`${news.id + 1}00`}
                >
                  <Card.Img
                    style={{
                      borderTopRightRadius: "20px",
                      borderTopLeftRadius: "20px",
                      width: "300px",
                      height: "150px",
                      objectFit: news.image ? `cover` : `scale-down`,
                    }}
                    variant="top"
                    src={news.image || alrajhi_logo}
                  />
                  <Card.Body
                    style={{
                      height: "230px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-around",
                    }}
                  >
                    <div className="d-flex flex-row justify-content-between align-items-center">
                      <div className={`news-badge ${news.type}`}>
                        {news.type}
                      </div>
                      <div>{news.date}</div>
                    </div>
                    <div className="title">
                      {news.title.length < 100
                        ? news.title
                        : news.title.substring(0, 100) + "..."}
                    </div>
                    {!news.isFromCMS && (
                      <div
                        className="subtitle text-black-50"
                        style={{ textOverflow: "ellipsis" }}
                      >
                        {news.description.length < 30
                          ? parse(news.description)
                          : parse(news.description.substring(0, 30)) + "..."}
                      </div>
                    )}
                    {news.isFromCMS && (
                      <div
                        className="subtitle text-black-50"
                        style={{ overflow: "hidden", textOverflow: "ellipsis" }}
                      >
                        {parse(news.description)}
                      </div>
                    )}
                    <div className="d-flex flex-row justify-content-between align-items-center pt-2">
                      <div className="d-flex flex-row align-items-center">
                        <img src={eye} height="13px" alt="eye" />
                        <span
                          className="text-black-50"
                          style={{ paddingLeft: "5px", paddingTop: "2px" }}
                        >
                          {news.seen || Math.floor(Math.random() * 100) + 1}
                        </span>
                      </div>
                      <div
                        className="d-flex flex-row align-items-center primary-color"
                        onClick={() => navigate(`/news/${news.slug}`)}
                      >
                        <span>Read More</span>
                        <img
                          src={arrow_right_circle}
                          width="16"
                          alt="arrow-right"
                          style={{ marginLeft: "5px" }}
                        />
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            ))}
        </Slider>
      </div>
      <div className="text-center">
        <PrimaryButton text="View all" onClick={() => navigate("/news")} />
      </div>
    </section>
  );
};

export default News;
